import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { createAxiosPayment } from "../utils/request";
import { walletApis } from "../utils/apis";

export const getWalletSummaryDetail = createAsyncThunk(
  "getWalletSummary",
  async (payload) => {
    try {
      const axiosInstance = createAxiosPayment();
      const response = await axiosInstance.get(
        `${walletApis.getWalletSummary}?user_id=${payload.userId}`,
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  },
);

export const getAllWalletTransaction = createAsyncThunk(
  "getAllWalletTransaction",
  async (payload = {}) => {
    try {
      const axiosInstance = createAxiosPayment();
      const params = new URLSearchParams();
      const sortBy = String(payload.sort_by ?? "CREATED_AT").toUpperCase();
      const sortOrder = payload.sort_order
        ? String(payload.sort_order).toUpperCase()
        : null;
      params.append("skip", payload.skip ?? 0);
      params.append("limit", payload.limit ?? 100);
      if (Array.isArray(payload.transaction_type)) {
        payload.transaction_type.forEach((type) => {
          params.append("transaction_type", type);
        });
      }
      if (payload.search) {
        params.append("search", payload.search);
      }
      if (sortOrder) {
        params.append("sort_by", sortBy);
        params.append("sort_order", sortOrder);
      }
      const response = await axiosInstance.get(
        `${walletApis.getAllWalletTransaction}?${params.toString()}`,
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  },
);

const giftcardSlice = createSlice({
  name: "giftcardSlice",
  initialState: {
    giftCards: null,
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getWalletSummaryDetail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getWalletSummaryDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.giftCards = action.payload;
      })
      .addCase(getWalletSummaryDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default giftcardSlice.reducer;
